import { useUserStore } from '@/store/user'
import { getData } from '../get-table'
import { HttpService } from '../http.service'
import { usePayrollStore } from '@/store/payroll-data'

const http = new HttpService()

export interface IncreaseSalaryRequest {
  payrollId: string
  increaseReasonId: string
  user: string
  incrementSalaryTypeId: string
  value: number
  employees: []
  appliesFrom: Date | ''
  errors: []
  observation: string
}

export interface IncreaseSalaryPreview {
  employee: string
  currency: string
  oldSalary: number
  newSalary: number
}

export async function getIncreaseSalaryRequests(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['increase_salary_requests.payroll_id=:payrollId']
  if (search) {
    where.push(
      `CONCAT(employees.code, employees.name, increase_salary_requests.user, increase_reasons.name,process_status.code,increase_salary_types.name) ILIKE '%${search}%'`
    )
  }
  // order by
  const modifier = [
    'GROUP BY increase_salary_requests.id , increase_reasons.id, increase_salary_types.id, process_status.code'
  ]
  dataOrder !== ''
    ? modifier.push(`order by ${dataOrder[1]} ${dataOrder[0]}`)
    : modifier.push('order by increase_salary_requests.created_at desc')

  // result
  const response: any = await getData({
    tables: ['pg_increase_salary_requests'],
    fields: [
      'increase_salary_requests.user as user',
      'increase_reasons.name as increaseReason',
      'increase_salary_requests.created_at',
      'increase_salary_types.name as increaseSalaryType',
      'increase_salary_requests.value as value',
      "string_agg(CONCAT(employees.first_name,' ',employees.lastname),',') as employees",
      'increase_salary_requests.applies_from as appliesFrom',
      'increase_salary_requests.errors as errors',
      'process_status.code as statusProcess',
      'increase_salary_requests.observation as observation'
    ],
    join: [
      'INNER JOIN process_status ON increase_salary_requests.process_status_id=process_status.id',
      'INNER JOIN increase_reasons ON increase_salary_requests.increase_reason_id = increase_reasons.id',
      'INNER JOIN increase_salary_types ON increase_salary_requests.increment_salary_type_id = increase_salary_types.id',
      'LEFT JOIN LATERAL jsonb_array_elements_text(increase_salary_requests.employees) r(employee) ON TRUE',
      'LEFT JOIN employees ON employees.id = r.employee::uuid'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getEmployees(appliesFrom: string) {
  const data = await getData<any>({
    tables: ['pg_employees'],
    fields: [
      'distinct employees.id',
      "CONCAT(employees.first_name,' ',coalesce(employees.second_name,''),' ',employees.lastname,' ',coalesce(employees.second_lastname,'')) as name",
      'directions.name as direccion',
      'managements.name as gerencia',
      'departments.name as departamento',
      'sucursals.name as sucursal',
      'positions.name as cargo',
      'turns.name as turno',
      'employees.leave_date as fechaSalida',
      'employees.code as codigo',
      "CONCAT(employees.code,' - ',employees.first_name,' ',coalesce(employees.second_name,''),' ',employees.lastname,' ',coalesce(employees.second_lastname,'')) as codigo_name",
      'false as isChecked'
    ],
    join: [
      'INNER JOIN salaries ON employees.id = salaries.employee_id',
      'LEFT JOIN directions ON employees.direction_id=directions.id',
      'LEFT JOIN managements ON employees.management_id=managements.id',
      'LEFT JOIN departments ON employees.department_id=departments.id',
      'LEFT JOIN sucursals ON employees.sucursal_id=sucursals.id',
      'LEFT JOIN positions ON employees.position_id=positions.id',
      'LEFT JOIN turns ON employees.turn_id=turns.id'
    ],
    where: [
      'employees.is_deleted=false',
      `employees.payroll_id =:payrollId`,
      `employees.joining_date<='${appliesFrom}'`,
      `employees.leave_date is null`
    ],
    options: {
      outputFormat: 'json'
    }
  })

  return data[0].results
}

export async function getListIncreaseReason(): Promise<[]> {
  const data = await getData<any>({
    tables: ['pg_increase_reasons'],
    fields: ['id', 'name'],
    where: ['country_id = :countryId'],
    options: {
      outputFormat: 'json'
    }
  })

  return data[0].results
}

export async function getListIncreaseType(): Promise<[]> {
  const data = await getData<any>({
    tables: ['pg_increase_salary_types'],
    fields: ['id', 'name'],
    options: {
      outputFormat: 'json'
    }
  })

  return data[0].results
}

export async function previewIncreaseSalaryRequest(
  data: IncreaseSalaryRequest
): Promise<any> {
  const storePayroll = usePayrollStore()

  const response: any = await http.post('employee/increase-salary/preview', {
    payrollId: storePayroll.payroll?.id,
    incrementSalaryTypeId: data.incrementSalaryTypeId,
    value: data.value,
    employees: data.employees,
    appliesFrom: data.appliesFrom
  })

  // for(let i = 0; i < 2000; i++){
  //   response?.data.push(response?.data[0])
  // }

  return response?.data
}

export async function createIncreaseSalaryRequest(
  data: IncreaseSalaryRequest
): Promise<any> {
  const storePayroll = usePayrollStore()
  const storeUser = useUserStore()

  const response: any = await http.post('employee/increase-salary', {
    payrollId: storePayroll.payroll?.id,
    increaseReasonId: data.increaseReasonId,
    user: storeUser.user?.name,
    incrementSalaryTypeId: data.incrementSalaryTypeId,
    value: data.value,
    employees: data.employees,
    appliesFrom: data.appliesFrom,
    observation: data.observation
  })

  return response?.data
}
